import React, { useEffect, useState } from 'react';
import {S3} from "@aws-sdk/client-s3";
import { S3_CONFIG } from '../config/config';

export interface LinkItem {
  image: string;
  is_thumbnail?: boolean;
  isThumbnail?: boolean;
}

export const useUpload = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [uploading, setUploading] = useState(false);
  const [bucketLinks, setBucketLinks] = useState<LinkItem[]>([]);

  const [error, setError] = useState();

  useEffect(() => {
  if (files.length > 0) {
    uploadFile(files).then().finally(() => {
      setFiles([]);
    });
  }
}, [files]);

//   useEffect(() => {
//     uploadFile().then();
//   }, [files]);


 const uploadFile = async (filteredFiles: File[]) => {
  setUploading(true);

  const S3_BUCKET = S3_CONFIG.bucket; // Replace with your bucket name
  const s3Client = new S3({
    forcePathStyle: false, // Configures to use subdomain/virtual calling format.
    endpoint: S3_CONFIG.endpoint,
    region: S3_CONFIG.region,
    credentials: {
      accessKeyId: S3_CONFIG.accessId,
      secretAccessKey: S3_CONFIG.secretKey
    }
  });

  for (const file of filteredFiles) { // filteredFiles used here
    const uuid = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const date = new Date();
    const filename = `${date.toISOString()}_${uuid}.jpg`;

    const params = {
      Bucket: S3_BUCKET,
      Key: `images/${filename}`,
      Body: file
    };

    try {
      s3Client.putObject(params).then(upload => {
        setBucketLinks(prevLinks => [...prevLinks || [], {
          image: `https://${S3_BUCKET}.s3.amazonaws.com/images/${filename}`,
          is_thumbnail: false
        }]);
      })

    } catch (error) {
      console.error(error);
      setError(error);
    }
  }

  setUploading(false);
};


  return {files, setFiles, uploadFile, error, uploading, bucketLinks, setBucketLinks};

}
